import { Button } from "@mui/material";
import domtoimage from 'dom-to-image';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CopyImageButton = ({ elementId, setShowImageCopy, adjustWidth=true, style, sx }) => {

  return (
    <Button
      size='small'
      style={style}
      sx={sx}
      onClick={() => {
        var node = document.getElementById(elementId);
        var headerCells = node.querySelectorAll('thead [role="columnheader"], thead th, .MuiTableHead-root .MuiTableCell-root');
        var headerCellsLength = headerCells.length;

        // Save the current computed width
        const originalWidth = node.style.width;

        if (headerCellsLength <= 7 && adjustWidth === true) {
          node.style.width = 'auto';
        }
        

        domtoimage.toBlob(node).then(function (blob) {
          const data = [new ClipboardItem({ [blob.type]: blob })];
          navigator.clipboard.write(data);

          setShowImageCopy(true);

          // Restore original width
          node.style.width = originalWidth;
        })
          .catch(function (error) {
            console.error('oops, something went wrong!', error);
            // Restore original width on error too
            node.style.width = originalWidth;
          });
      }}
      endIcon={<ContentCopyIcon />}
    >
      Copy Image
    </Button>
  );
};

export default CopyImageButton;